import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-vis-component": "" }

import { Line, LineConfigInterface, NumericAccessor } from '@unovis/ts'
import { onMounted, onUnmounted, computed, ref, watch, nextTick, inject } from 'vue'
import { arePropsEqual, useForwardProps } from '../../utils/props'
import { componentAccessorKey } from '../../utils/context'


export const VisLineSelectors = Line.selectors

type Props = LineConfigInterface<Datum>

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    color: { type: [Function, String, Array, null] },
    curveType: {},
    lineWidth: {},
    lineDashArray: { type: [Function, null] },
    fallbackValue: {},
    highlightOnHover: { type: Boolean },
    cursor: { type: [Function, String, null] },
    x: { type: [Function, Number, null] },
    y: { type: [Function, Number, null, Array] },
    id: { type: Function },
    xScale: { type: [Object, Function] },
    yScale: { type: [Object, Function] },
    excludeFromDomainCalculation: { type: Boolean },
    duration: {},
    events: {},
    attributes: {},
    data: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// !!! This code was automatically generated. You should not change it !!!
const accessor = inject(componentAccessorKey)

// data and required props 


const data = computed(() => accessor.data.value ?? props.data)
// config
const config = useForwardProps(props)

// component declaration
const component = ref<Line<Datum>>()


onMounted(() => {
  nextTick(() => {
    component.value = new Line<Datum>(config.value)
    component.value?.setData(data.value)
    accessor.update(component.value)
  })
})

onUnmounted(() => {
  component.value?.destroy()
  accessor.destroy()
})

watch(config, (curr, prev) => {
  if (!arePropsEqual(curr, prev)) {
    component.value?.setConfig(config.value)
  }
})

watch(data, () => {
  component.value?.setData(data.value)
})

__expose({
  component
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})